import { StalePostRecalculateModal } from "./StalePostRecalculateModal";
import { useQuestionnaireListContext } from "./context/useQuestionnaireList";

export const StalePostModal = () => {
    const { post } = useQuestionnaireListContext();

    return <StalePostRecalculateModal post={post} />;
};
